<ng-container [formGroup]="parentForm" #testForm>
  <div class="current-home-address">
    <div class="row">
      <div class="col l12 m12 s12">
        <div class="field-group searchfield">
          <!-- <mat-form-field class="inputfield filter-search-field">
            <span class="material-icons">search</span>
            <img src="/assets/images/loader-white.gif" alt="img" style="display: none;">
            <input matInput  value="" aria-label="Number" autocomplete="off" id='searchBox'>
          </mat-form-field> -->
          <mat-form-field appearance="outline" class="custom-form-field">

            <img src="/assets/images/loader-white.gif" alt="img" style="display: none;">
            <input type="text"  (keyup)="search(addressInput)"
              placeholder="Search Address"
              aria-label="Number"
               matInput
              #addressInput
              [matAutocomplete]="auto"
               >

               <mat-autocomplete #auto="matAutocomplete" >
                 <mat-option *ngIf="loading;else content"> loading...</mat-option>
                 <ng-template #content>
                  <mat-option color="accent" *ngFor="let option of allAddress" [value]="option.formattedAddress" (click)="populateAddress(option)" >
                    {{option.formattedAddress}}
                    </mat-option>
                 </ng-template>

                  </mat-autocomplete>
               <!--
                  [matAutocomplete]="auto" // put this in input
                <mat-autocomplete #auto="matAutocomplete">
                <mat-option color="accent" *ngFor="let option of filteredEmployer | async" [value]="option">
                {{option}}
                </mat-option>
                  </mat-autocomplete> -->
                  <button mat-button class="add" type="button" mat-icon-button matSuffix (click)="getAddress(addressInput)">
                    <mat-icon class="material-icons green-text">search</mat-icon>
                    </button>
          </mat-form-field>

        </div>
      </div>
    </div>
    <div class="row">
      <div class="col l3 m6 s12">
        <mat-label>Unit/Apartment</mat-label>
          <mat-form-field appearance="outline" class="custom-form-field">
            <input matInput placeholder="Enter apartment number" formControlName="tlx_street">
          </mat-form-field>
      </div>
      <div class="col l3 m6 s12">
        <mat-label>Street Number</mat-label>
          <mat-form-field appearance="outline" class="custom-form-field">
            <input matInput placeholder="Enter street number" formControlName="new_streetnumber">
          </mat-form-field>

      </div>
      <div class="col l3 m6 s12">

        <mat-label>Street Name</mat-label>
          <mat-form-field appearance="outline" class="custom-form-field">
            <input matInput placeholder="Enter street name" formControlName="tlx_streetaddress2">
          </mat-form-field>

      </div>
      <div class="col l3 m6 s12">
        <div class="field-group selectfield" [ngClass]="{'danger': isStreetValid == false}">
          <mat-label>Street Type</mat-label>
          <!-- <mat-form-field appearance="fill" class="selectfield">
          <mat-select  formControlName="new_streettype">
            <mat-option *ngFor="let element of streetTypeKeys" [value]="streetTypes[element]">
              {{element}}
            </mat-option>
          </mat-select>
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="custom-form-field">
            <input type="text" placeholder="Enter Street Type" (keyup)="getFilteredStreetType($event)"
              matInput [value]="new_streettype_Formatted" [matAutocomplete]="streetType" (blur)="onFormInputTypeBlur($event, 'streetType')">
            <mat-autocomplete #streetType="matAutocomplete" (optionSelected)="setFilteredStreetType($event)">
              <mat-option *ngFor="let element of filterStreetTypekeys" [value]="element">
                {{element}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>

      <div class="col l3 m6 s12">
          <mat-label>City</mat-label>
          <mat-form-field appearance="outline" class="custom-form-field">
            <input matInput placeholder="Enter your city" formControlName="tlx_city">
          </mat-form-field>
         

      </div>

      <div class="col l3 m6 s12">
        <div class="field-group selectfield">
          <mat-label>State</mat-label>
          <mat-form-field appearance="fill" class="selectfield">
            <mat-select  formControlName="new_state">
              <mat-option *ngFor="let element of stateKeys" [value]="states[element]">
                {{element}}
              </mat-option>
            </mat-select>
            </mat-form-field>
       
        </div>
      </div>


      <div class="col l3 m6 s12">
        <div class="field-group selectfield" [ngClass]="{'danger': isCountryValid == false}">
          <mat-label>Country</mat-label>
          <!-- <mat-form-field appearance="fill" class="selectfield">
            <mat-select  formControlName="new_country">
              <mat-option value="18952afd-55eb-ea11-a815-000d3a799a0d">Australia</mat-option>
              <mat-option *ngFor="let element of countryKeys" [value]="countries[element]">
                {{element}}
              </mat-option>
            </mat-select>
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="custom-form-field">
            <input type="text" placeholder="Enter Country" (keyup)="getFilteredCountries($event)" matInput
              [value]="new_country_Formated" [matAutocomplete]="countryType" (blur)="onFormInputTypeBlur($event, 'countryType')">
            <mat-autocomplete #countryType="matAutocomplete" (optionSelected)="setFilteredCountry($event)">
              <mat-option *ngFor="let element of filteredCountries" [value]="element.tlx_countryid">
                {{element.tlx_name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>


      <div class="col l3 m6 s12">

        <mat-label>Zip/Postal Code</mat-label>
          <mat-form-field  appearance="outline" class="custom-form-field">
            <input matInput placeholder="Enter zip/postal code" formControlName="tlx_postcode">
          </mat-form-field>
         

      </div>

      <div class="col l3 m6 s12" *ngIf="formNumber !== 1 && formNumber !== 2">
        <div class="field-group selectfield addressStatus">
          <mat-label>Address Status</mat-label>
          <mat-form-field appearance="fill" class="selectfield">
            <mat-select  formControlName="new_housingsituation">
              <mat-option>None</mat-option>
              <mat-option value="{{housSituation.BOARDING }}">Boarding</mat-option>
              <mat-option value="{{housSituation.CARAVAN }}">Caravan </mat-option>
              <mat-option value="{{housSituation.OWN_HOME }}">Own Home  </mat-option>
              <mat-option value="{{housSituation.Own_Home_Mortgage  }}">Own Home Mortgage </mat-option>
              <mat-option value="{{housSituation.RENTING  }}">Renting </mat-option>
              <mat-option value="{{housSituation.WITH_PARENTS  }}">With Parents  </mat-option>
              <mat-option value="{{housSituation.OTHER  }}">Other </mat-option>
            </mat-select>
         
          </mat-form-field>
        </div>
      </div>
    </div>

  </div>
</ng-container>
